import { useEffect, useState } from 'react';
import { api } from '../../lib/api';

const SEV_STYLES: Record<string, string> = {
  strength: 'text-mono-green',
  minor: 'text-alarm-amber',
  major: 'text-alarm-red',
  critical: 'text-alarm-red font-semibold',
};

export default function Analytics() {
  const [feedback, setFeedback] = useState<any[] | null>(null);
  useEffect(() => { api.adminFeedbackStats().then((r) => setFeedback(r.feedback)); }, []);

  if (!feedback) return <p className="text-mono-white/60">Loading…</p>;

  const strengths = feedback.filter((f) => f.severity === 'strength').slice(0, 10);
  const issues = feedback.filter((f) => f.severity !== 'strength').slice(0, 20);

  return (
    <div>
      <h1 className="text-2xl font-semibold mb-2">Analytics</h1>
      <p className="text-mono-white/50 text-sm mb-6">Aggregated feedback markers across all runs. Drill into a specific run via the Runs tab.</p>

      <div className="grid md:grid-cols-2 gap-6">
        <div>
          <h3 className="text-mono-green font-semibold mb-3">Most-common strengths</h3>
          {strengths.length === 0 ? (
            <p className="text-mono-white/40 text-sm italic">No strengths recorded yet.</p>
          ) : (
            <div className="space-y-2">
              {strengths.map((s, i) => (
                <div key={i} className="panel p-3 flex justify-between items-start gap-3">
                  <span className={`text-sm ${SEV_STYLES.strength}`}>{s.message}</span>
                  <span className="font-mono text-xs text-mono-white/50 shrink-0">×{s.count}</span>
                </div>
              ))}
            </div>
          )}
        </div>
        <div>
          <h3 className="text-alarm-red font-semibold mb-3">Most-common failure modes</h3>
          {issues.length === 0 ? (
            <p className="text-mono-white/40 text-sm italic">No issues recorded yet.</p>
          ) : (
            <div className="space-y-2">
              {issues.map((s, i) => (
                <div key={i} className="panel p-3 flex justify-between items-start gap-3">
                  <span className={`text-sm ${SEV_STYLES[s.severity] || ''}`}>
                    <span className="text-[10px] uppercase tracking-widest opacity-70 mr-2">{s.severity} · {s.category}</span>
                    {s.message}
                  </span>
                  <span className="font-mono text-xs text-mono-white/50 shrink-0">×{s.count}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <p className="text-mono-white/40 text-xs mt-6 italic">
        Source: <code className="font-mono text-mono-cyan">feedback_taxonomy</code> table grouped by category, severity, and message.
      </p>
    </div>
  );
}
